import React, { useState, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  Center,
  ColorInput,
  Text,
  Select,
} from "@mantine/core";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto, IconUpload, IconVideo } from "@tabler/icons-react";
import classes from "./add.module.css";
import { RowDataBanner } from "./types";

interface AddBannerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddBanner: (newBannerData: RowDataBanner) => void;
}

const AddBannerModal: React.FC<AddBannerModalProps> = ({
  isOpen,
  onClose,
  onAddBanner,
}) => {
  const [newBanner, setNewBanner] = useState<RowDataBanner>({
    id: "",
    title: "",
    imageSrc: "",
    // color: "",
    route: "",
    show: false,
    action: "Edit",
    websiteRoute: "",
  });
  const imageDropzoneRef = useRef<() => void>(null);

  const handleImageUpload = (files: File[]) => {
    const file = files[0];
    if (file) {
      setNewBanner({ ...newBanner, imageSrc: file });
    }
  };

  const handleAddBanner = () => {
    // Check if any required fields are empty
    if (!newBanner.title || !newBanner.imageSrc || !newBanner.route) {
      alert("Please fill in all the required fields");
      return;
    }

    onAddBanner(newBanner);

    // Clear inputs and reset state
    setNewBanner({
      id: "",
      title: "",
      imageSrc: "",
    //   color: "",
      route: "",
      show: false,
      action: "Edit",
      websiteRoute: "",
    });

    onClose();
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setNewBanner({
      id: "",
      title: "",
      imageSrc: "",
    //   color: "",
        route: "",
      show: false,
      action: "Edit",
      websiteRoute: "",
    });

    // Call the onClose function
    onClose();
  };

  return (
    <Modal
      style={{ zIndex: "100" }}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New Banner
        </div>
      }
      opened={isOpen}
      onClose={handleClose}
    >
      <TextInput
        label="Title"
        required
        placeholder="Input title"
        mb="sm"
        maxLength={255}
        value={newBanner.title}
        onChange={(event) =>
          setNewBanner({ ...newBanner, title: event.currentTarget.value })
        }
      />

      <Text className={classes.Text}>
        Image <span className={classes.format}>(.jpg, .png)</span><span style={{ color: 'red' }}>*</span>
      </Text>
      <Dropzone
        onDrop={handleImageUpload}
        accept={["image/*"]}
        openRef={imageDropzoneRef}
      >
        <div className={classes.imageContainer}>
          {newBanner.imageSrc ? (
            <img
              src={URL.createObjectURL(newBanner.imageSrc)}
              alt="Image"
              className={classes.imageSize}
            />
          ) : (
            <p>
              <IconPhoto />
            </p>
          )}
        </div>
      </Dropzone>
      <Group>
        <Button
          onClick={() => imageDropzoneRef.current?.()}
          className={classes.imageButton}
        >
          <IconPhoto />
          Upload Image
        </Button>
      </Group>

      {/* <ColorInput
        label="Color"
        placeholder="Select a color"
        mb="sm"
        value={newBanner.color}
        onChange={(color) => setNewBanner({ ...newBanner, color: color })}
      /> */}
      <Select
            label="Route"
            placeholder="Select route"
            required
            data={[
                { value: 'NONE', label: 'None' },
                
                { value: 'ViewnetCash', label: 'ViewnetCash' },
                { value: 'MyQR', label: 'MyQR' },
                { value: 'Rewards', label: 'Rewards' },
                { value: 'Me', label: 'Me' },

                { value: 'Membership', label: 'Membership' },
                { value: 'MyVouchers', label: 'MyVouchers' },
                { value: 'MyPurchases', label: 'MyPurchases' },
                { value: 'FAQ', label: 'FAQ' },
                { value: 'TermsOfUse', label: 'TermsOfUse' },
                { value: 'PrivacyPolicy', label: 'PrivacyPolicy' },
                { value: 'PriceList', label: 'PriceList' },
                { value: 'DailyFeed', label: 'DailyFeed' },
                { value: 'MyMerchandise', label: 'MyMerchandise' },

                { value: 'CashHistory', label: 'CashHistory' },
                { value: 'CoinHistory', label: 'CoinHistory' },

                { value: 'Notification', label: 'Notification' },
            ]}
            onChange={(value, option) =>
                setNewBanner({ ...newBanner, route: value, websiteRoute: '' })
            }            
        />

      <TextInput
        label="Website Route" 
        placeholder="https://example.com"
        description='Set Route to "None" if specifying a website route.'
        my="sm"
        maxLength={255}
        value={newBanner.websiteRoute ?? ''}
        disabled={newBanner.route !== 'NONE'} 
        onChange={(event) =>
          setNewBanner({ ...newBanner, websiteRoute: event.currentTarget.value })
        }
      />

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonBack}>
          Back
        </Button>
        <Button onClick={handleAddBanner} className={classes.buttonSubmit}>
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default AddBannerModal;
